import { GzFirewallSettingsWebComponent } from './component/GzFirewallSettingsWebComponent';

export { GzFirewallSettingsWebComponent };
